import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: Index,
  beforeLoad: async ({ context }) => {
    if (context.auth?.isAuthenticated) {
      throw redirect({
        to: '/app',
      })
    } else {
      throw redirect({
        to: '/login',
      })
    }
  },
})

function Index() {
  return null
}

export default Index
